/* eslint-disable @typescript-eslint/explicit-function-return-type */
/* eslint-disable require-jsdoc */
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { APP_INITIALIZER, Injectable, LOCALE_ID, NgModule } from '@angular/core';
import { BrowserModule, HAMMER_GESTURE_CONFIG, HammerGestureConfig, HammerModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { RouteReuseStrategy, RouterModule, UrlSerializer } from '@angular/router';

import { CurrencyPipe, DatePipe, registerLocaleData } from '@angular/common';
import localeAr from '@angular/common/locales/ar-AE';
import localeQa from '@angular/common/locales/ar-QA';
import localeSr from '@angular/common/locales/ar-SA';
import localeEn from '@angular/common/locales/en';
import localeGb from '@angular/common/locales/en-GB';
import localeIn from '@angular/common/locales/en-IN';
import localeEs from '@angular/common/locales/es';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MsalService } from '@azure/msal-angular';
import * as Hammer from 'hammerjs';
import { environment } from 'src/environments/environment';
import { routes } from './app-routing.module';
import { AppComponent } from './app.component';
import { LogoutExtComponent } from './b2c-policy-core/logout-ext/logout-ext.component';
import { MSALProviders } from './b2c-policy-core/msal-provider';
import { appConfigFactory } from './config/configuration/init-config.factory';
import { ConfigurationService } from './config/configuration/service/configuration.service';
import { AlertDialogComponent } from './dialogs/alert-dialog/alert-dialog.component';
import { ChatNotificationComponent } from './dialogs/chat-notification/chat-notification.component';
import { ConfirmDialogComponent } from './dialogs/confirm-dialog/confirm-dialog.component';
import { GtMotiveEstimationDialogComponent } from './dialogs/gt-motive-estimation-dialog/gt-motive-estimation-dialog.component';
import { MultiActionConfirmDialogComponent } from './dialogs/multi-action-confirm-dialog/multi-action-confirm-dialog.component';
import { NotificationComponent } from './dialogs/notification/notification.component';
import { ToastComponent } from './dialogs/toast/toast.component';
import { DirectiveModule } from './helper/directive/directive.module';
import { PipeModule } from './helper/pipe.module';
import { NumberSuffixPipe } from './helper/pipe/number-suffix/number-suffix.pipe';
import { interceptorProviders } from './http-interceptors';
import CustomUrlSerializer from './http-interceptors/custom-Url-Serializer';
import { RemountRouteReuseStrategy } from './helper/remount-route-reuse.strategy';
import { IconsModule } from './icons.module';
import { LayoutModule } from './layout/layout.module';
import { MaterialModule } from './material.module';
import { initializeMsalStorage } from './msal-storage.factory';
import { NgxTranslateModule } from './translate/translate.module';
import { WidgetsModule } from './widgets/widgets.module';
import { CommonService } from './services/common/common.service';

import { FreeTrialSignupComponent } from './public/free-trial-signup/free-trial-signup.component';
import { AgentixTrialSignupComponent } from './public/agentix-trial-signup/agentix-trial-signup.component';
import { AgentixTrialMarketingPanelComponent } from './public/agentix-trial-signup/components/agentix-trial-marketing-panel/agentix-trial-marketing-panel.component';
import { AgentixTrialSignupBrandComponent } from './public/agentix-trial-signup/components/agentix-trial-signup-brand/agentix-trial-signup-brand.component';
import { OnboardingComponent } from './public/onboarding/onboarding.component';
import { NgOtpInputModule } from 'ng-otp-input';
import { RECAPTCHA_SETTINGS, RecaptchaFormsModule, RecaptchaModule, RecaptchaSettings, RECAPTCHA_LANGUAGE } from 'ng-recaptcha';
import { SuccessDialogComponent } from './dialogs/success-dialog/success-dialog.component';
import { ServiceWorkerModule } from '@angular/service-worker';
import { DEFAULT_AI_TIMEOUT, RECURSION_MAX_RETRIES, ENABLE_AI_RECURSION } from './helper/form/vehicle.helper';
import { OrganizationSelectionComponent } from './dialogs/organization-selection/organization-selection.component';
import { WordsinitialsPipe } from './pipe/wordinitals/wordsinitials.pipe';
import { AiAgentExternalAssistantComponent } from './modules/ai-studio/ai-agent-external-assistant/ai-agent-external-assistant.component';
import { ExternalAssistantAccessDeniedComponent } from './modules/ai-studio/ai-agent-external-assistant/external-assistant-access-denied/external-assistant-access-denied.component';
import { TelrReturnComponent } from './public/telr-return/telr-return.component';
import { TelrPaymentStatusDialogComponent } from './dialogs/telr-payment-status-dialog/telr-payment-status-dialog.component';
import { PublicAccessModule } from './public/public-access.module';
import { PublicClaimActionsModule } from './public/public-claim-actions.module';
import { PublicSubmitMissingInfoModule } from './public/public-submit-missing-info.module';
import { ErrorModule } from './shared/error-page/error.module';

registerLocaleData(localeIn);
registerLocaleData(localeAr);
registerLocaleData(localeEn);
registerLocaleData(localeGb);
registerLocaleData(localeSr);
registerLocaleData(localeQa);
registerLocaleData(localeEs);
@Injectable()
export class MyHammerConfig extends HammerGestureConfig {
  override overrides = <any>{
    'swipe': {
      // override default settings
      velocity: 0.4,
      threshold: 20,
      direction: Hammer.DIRECTION_ALL,
      enabled: true
    }
  }
}

@NgModule({ declarations: [
        AppComponent,
        AlertDialogComponent,
        ConfirmDialogComponent,
        ToastComponent,
        NotificationComponent,
        LogoutExtComponent,
        GtMotiveEstimationDialogComponent,
        ChatNotificationComponent,
        MultiActionConfirmDialogComponent,
        FreeTrialSignupComponent,
        AgentixTrialSignupComponent,
        AgentixTrialMarketingPanelComponent,
        AgentixTrialSignupBrandComponent,
        OnboardingComponent,
        SuccessDialogComponent,
        OrganizationSelectionComponent,
        AiAgentExternalAssistantComponent,
        ExternalAssistantAccessDeniedComponent,
        TelrReturnComponent,
        TelrPaymentStatusDialogComponent,
    ],
    bootstrap: [AppComponent], imports: [HammerModule,
        FormsModule,
        ReactiveFormsModule,
        BrowserModule,
        BrowserAnimationsModule,
        LayoutModule,
        RouterModule.forRoot(routes),
        IconsModule,
        NgxTranslateModule,
        MaterialModule,
        PipeModule,
        DirectiveModule,
        WidgetsModule,
        NgOtpInputModule,
        RecaptchaFormsModule,
        RecaptchaModule,
        WordsinitialsPipe,
        PublicAccessModule,
        PublicClaimActionsModule,
        PublicSubmitMissingInfoModule,
        ErrorModule,
        ServiceWorkerModule.register('ngsw-worker.js', {
            enabled: true,
            // Register the ServiceWorker as soon as the application is stable
            // or after 30 seconds (whichever comes first).
            registrationStrategy: 'registerWhenStable:30000'
        })], providers: [
        { provide: UrlSerializer, useClass: CustomUrlSerializer },
        // Routes flagged `remountOnParamChange` (repair workspace) are created again for another repair.
        { provide: RouteReuseStrategy, useClass: RemountRouteReuseStrategy },
        interceptorProviders,
        [{ provide: DEFAULT_AI_TIMEOUT, useValue: environment.ai.recursionTimeout },
            { provide: RECURSION_MAX_RETRIES, useValue: environment.ai.maxRetryCount },
            { provide: ENABLE_AI_RECURSION, useValue: environment.ai.enableRecursion }],
        MSALProviders,
        {
            provide: HAMMER_GESTURE_CONFIG,
            useClass: MyHammerConfig
        },
        {
            provide: APP_INITIALIZER,
            useFactory: () => initializeGoogleMap,
            multi: true
        }, {
            provide: APP_INITIALIZER,
            useFactory: () => initializeOpenCV,
            multi: true
        },
        {
            provide: APP_INITIALIZER,
            useFactory: () => initializeMsalStorage,
            multi: true
        },
        {
            provide: APP_INITIALIZER,
            useFactory: appConfigFactory,
            deps: [ConfigurationService, MsalService],
            multi: true
        },
        DatePipe,
        NumberSuffixPipe,
        CurrencyPipe,
        PipeModule,
        {
            provide: LOCALE_ID,
            useFactory: (commonService: CommonService) => commonService.getLocale(),
            deps: [CommonService]
        },
        {
            provide: RECAPTCHA_SETTINGS,
            useValue: {
                siteKey: environment.siteKey
            } as RecaptchaSettings,
        },
        {
            provide: RECAPTCHA_LANGUAGE,
            useFactory: (commonService: CommonService) => commonService.getLocale(),
            deps: [CommonService]
        },
        provideHttpClient(withInterceptorsFromDi())
    ] })

export class AppModule { }

/**
 * Loads the Google Maps Places script on app startup.
 * @returns promise that resolves after the script tag is appended
 */
function initializeGoogleMap(): Promise<boolean> {
  return new Promise((resolve) => {
    const script = document.createElement('script');
    script.type = 'text/javascript';
    script.src = `https://maps.googleapis.com/maps/api/js?key=${environment.googleMapsKey}&libraries=places&language=en`;
    document.getElementsByTagName('head')[0].appendChild(script);
    resolve(true);
  });
}

/**
 * Loads OpenCV unless the current route is file-claim.
 * @returns promise that resolves after the script tag is appended (or skipped)
 */
function initializeOpenCV(): Promise<boolean> {
  return new Promise((resolve) => {
    if(!location.href.includes('/file-claim/')) {
      const script = document.createElement('script');
      script.type = 'text/javascript';
      script.async = true;
      script.src = '/assets/lib/opencv.js';
      document.getElementsByTagName('head')[0].appendChild(script);
    }
    resolve(true);
  });
}
